/**************************************************
 * Nombre:       CatalogoLista
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import ListaOfertas from "./ListaOfertas";
import {useResponsive} from "../../../../Modulo_responsive/Hooks/useResponsive";
import {useContext, useEffect, useState} from "react";
import {contexApp} from "../../../../App";


const CatalogoLista = () => {
    const {sCell} = useResponsive()
    const cData = useContext(contexApp)
    const [escuelas, setEscuelas] = useState([])


    useEffect(() => {

        if (cData.escuelas.length > 0) {
            setEscuelas(cData.escuelas)
        }

    }, [cData])
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 0}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}}
                      sx={{justifyContent: 'flex-start', mt: sCell ? 2 : 8, px: sCell ? 2 : 6}}>
                    <ListaOfertas items={escuelas}/>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default CatalogoLista

